import { MarkerInfoState } from '../../../shared/marker-info.state';

export class SharedResultComponent extends MarkerInfoState {
  public onItemClick(): void {
    this.itemClicked.emit();
  }
}
